import {gsap} from "gsap/all";
import $ from "jquery";

export class CausalityEffects {

  constructor(el, level) {
    this.level = level;
    this.$el = $(el);
    this.mainTimeline = this.buildTimeline();
  }

  play() {
    gsap.set(this.$el, {autoAlpha: 1});
    this.mainTimeline.seek(0);
    this.mainTimeline.play();
  }

  hide(delay = 0) {
    const tl = gsap.timeline();
    tl.to(this.$el, {autoAlpha: 0}, delay);
    tl.add(() => this.mainTimeline.pause());
  }

  buildTimeline() {
    const tl = gsap.timeline({paused: true});
    this.addStateMachineToTimeline({timeline: tl, index: 0});
    return tl;
  }

  addStateMachineToTimeline({timeline, index}) {
    const level = this.level;
    const lottieDuration = this.$el.find(".lottie-animation").eq(index).data('lottie').duration;

    // Prevent triggering of still there popup
    timeline.add(() => app.resetTimer());

    // Hide UI on animation
    timeline.add(() => app.bioScenes[app.level].hideUI());

    timeline.to(this.$el.find(".lottie-animation").eq(index), {
      autoAlpha: 1,
      duration: 0.6,
      ease: "sine.inOut",
      scale: 1,
      onStart: function () {
        const dotLottie = $(this.targets()).data('lottie');
        dotLottie.setFrame(0);
        dotLottie.stateMachineLoad('StateMachine1');
        dotLottie.setFrame(0);
        dotLottie.stateMachineStart();

        // dotLottie.removeEventListener('stateMachineTransition');
        // dotLottie.addEventListener('stateMachineTransition', ({ fromState, toState }) => {
        //   console.log(`Transitioning from ${fromState} to ${toState}`);
        // });
        //
        // dotLottie.removeEventListener('stateMachineStateEntered');
        // dotLottie.addEventListener('stateMachineStateEntered', ({ state }) => {
        //   console.log('Entered state:', state);
        // });

        dotLottie.removeEventListener('frame');
        dotLottie.addEventListener('frame', ({currentFrame}) => {
          if (currentFrame > 0.1) {
            app.audio.play(`audio/MNS2_Int5.2 Effet domino_SFX/MNS2_ME_INT5.2_SFXspecLoupe${level.replace("level", "")}.mp3`, 1, true);
            dotLottie.removeEventListener('frame');
          }
        });

      }
    }, 0)

    // Prevent triggering of still there popup
    timeline.add(() => app.resetTimer());

    // Show conclusion popup and UI back on tooltip close
    timeline.add(async () => {
      await app.toggleTooltip(true, app.level + "_full_biodiversity_tooltip")
      this.hide(0);
      app.bioScenes[app.level].showUI(1)
    }, lottieDuration - 6);

    // Prevent triggering of still there popup
    timeline.add(() => app.resetTimer());
  }

  reset() {
    this.mainTimeline.pause();
    this.mainTimeline.seek(0);
    gsap.set(this.$el.find(".lottie-animation"), {autoAlpha: 0})

    this.$el.find(".lottie-animation").each(function (i, n) {
      const dotLottie = $(n).data("lottie");
      dotLottie.stateMachineStop();
      dotLottie.setFrame(0);
      dotLottie.stop();
    })
  }

}
